export default "__VITE_ASSET__HqR8dUCY__"